import { render, staticRenderFns } from "./CaretDownIcon.vue?vue&type=template&id=e04dd596&"
import script from "./CaretDownIcon.vue?vue&type=script&lang=js&"
export * from "./CaretDownIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports